import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { DomainBasedSignUpSetting } from '@shared/ui/organisms/settings/DomainBasedSignUpSetting';
import { TenantBasedSignUpSetting } from '@shared/ui/organisms/settings/TenantBasedSignUpSetting';
import { LockedSignupDomainsSetting } from '@shared/ui/organisms/settings/LockedSignupDomainsSetting';
import { SectionSaveButton } from './SectionSaveButton';

export function SignupRegisterPanel() {
  const { t } = useTranslation();
  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.signup-and-register-tab')}</HeadlineSmall>
      <DomainBasedSignUpSetting settingsView={true} />
      <TenantBasedSignUpSetting />
      <LockedSignupDomainsSetting />
      <SectionSaveButton />
    </>
  );
}
